import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "../../helper/apiCall";
import ENDPOINTS from "../../constants/endpoints";

const initialState = {
    loading: false,
    ageGroups: [],
    selectedAgeGroup: null,
    error: null
};

export const getAgeGroups = createAsyncThunk(
    "getAgeGroups",
    async (branchId, thunkAPI) => {
        try {       
            const response = await client.get(`${ENDPOINTS.AGE_GROUPS.GET_LIST}?branchId=${branchId}`, {
                token: thunkAPI.getState().auth.token
            });
            // API pagination formatında döndüğü için items array'ini alıyoruz
            return response.data.items || response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

export const deleteAgeGroup = createAsyncThunk(
    "deleteAgeGroup",
    async (id, thunkAPI) => {
        try {
            const response = await client.delete(ENDPOINTS.AGE_GROUPS.DELETE.replace(':id', id), null, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

export const addAgeGroup = createAsyncThunk(
    "addAgeGroup",
    async (body, thunkAPI) => {
        try {
            const response = await client.post(ENDPOINTS.AGE_GROUPS.CREATE, body, {
                token: thunkAPI.getState().auth.token
            });
            
            // Response'dan gelen id ile request body'yi birleştir
            const result = {
                id: response.data.id,
                name: body.name,
                branchId: body.branchId
            };
            return result;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

export const updateAgeGroup = createAsyncThunk(
    "updateAgeGroup",
    async (body, thunkAPI) => {
        try {
            const response = await client.put(ENDPOINTS.AGE_GROUPS.UPDATE, body, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

export const getAgeGroupById = createAsyncThunk(
    "getAgeGroupById",
    async (id, thunkAPI) => {
        try {
            const response = await client.get(ENDPOINTS.AGE_GROUPS.GET_BY_ID.replace(':id', id), {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

const ageGroupsSlice = createSlice({
    name: "ageGroups",
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        clearSelectedAgeGroup: (state) => {
            state.selectedAgeGroup = null;
        },
        setSelectedAgeGroup: (state, action) => {
            state.selectedAgeGroup = action.payload;
        }
    },
    extraReducers(builder) {
        builder.addCase(getAgeGroups.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getAgeGroups.fulfilled, (state, action) => {
            state.loading = false;
            state.ageGroups = action.payload;
        });
        builder.addCase(getAgeGroups.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        
        builder.addCase(deleteAgeGroup.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(deleteAgeGroup.fulfilled, (state, action) => {
            state.loading = false;
            // Silinen age group'u listeden çıkar
        });
        builder.addCase(deleteAgeGroup.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        
        builder.addCase(addAgeGroup.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(addAgeGroup.fulfilled, (state, action) => {
            state.loading = false;
            // Yeni age group'u listeye ekle
            
        });
        builder.addCase(addAgeGroup.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        
        builder.addCase(getAgeGroupById.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getAgeGroupById.fulfilled, (state, action) => {
            state.loading = false;
            state.selectedAgeGroup = action.payload;
        });
        builder.addCase(getAgeGroupById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        
        builder.addCase(updateAgeGroup.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(updateAgeGroup.fulfilled, (state, action) => {
            state.loading = false;
            // Güncellenen age group'u listede güncelle
           
        });
        builder.addCase(updateAgeGroup.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export const { clearError, clearSelectedAgeGroup, setSelectedAgeGroup } = ageGroupsSlice.actions;
export default ageGroupsSlice.reducer; 